import { provideGalaxyDateAdapter } from '@vendasta/galaxy/datepicker';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ATLAS_CONFIG_TOKEN, PamReason } from '@galaxy/atlas';
import { CoreModule, provideErrorTracking } from '@galaxy/core';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyI18NModule } from '@vendasta/galaxy/i18n';
import { GalaxyDefaultProviderOverrides } from '@vendasta/galaxy/provider-default-overrides';
import { OAuthModule } from 'angular-oauth2-oidc';
import { of } from 'rxjs';
import En from '../assets/i18n/en_devel.json';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { AuthedAppModule } from './authed-app.module';
import { LogoutComponent } from './pages/logout';
import { Oauth2PlaygroundModule } from './pages/oauth2-playground/oauth2-playground.module';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OAuth2Module } from '@vendasta/oauth2';
import { AiAssistantI18nModule } from '@galaxy/ai-assistant';
import { provideProtoTransport } from '@vendasta/protos';

// Declare environment variables
declare global {
  interface Window {
    environment: string;
  }
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    Oauth2PlaygroundModule,
    LogoutComponent,
    RouterModule,
    AuthedAppModule,
    GalaxyI18NModule,
    TranslateModule,
    MatDialogModule,
    LexiconModule.forRoot({
      componentName: 'admin-center/vendasta-center-client',
      baseTranslation: En,
    }),
    OAuthModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    OAuth2Module,
    AiAssistantI18nModule,
  ],
  providers: [
    provideGalaxyDateAdapter(),
    provideProtoTransport(),
    provideErrorTracking(),
    ...GalaxyDefaultProviderOverrides,
    {
      provide: ATLAS_CONFIG_TOKEN,
      useValue: of({
        partnerId: 'VA',
        serviceProviderId: 'admin-client',
        entitlementId: 'superadmin',
        defaultPamReason: PamReason.DeveloperOperations,
      }),
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
